import { MenuItemComponentProps } from "./types";
import { styled } from "@mui/material";

const MenuItem = ({ item, depth = 1, isOpen }: MenuItemComponentProps) => {
  return (
    <StyledItemWrapper
    data-isopen={isOpen}
      className={`level-${depth}`}
      key={`item-level-${depth} ${item.id}`}
    >
      {item.name}
    </StyledItemWrapper>
  );
};

export default MenuItem;
const StyledItemWrapper = styled("span")(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  textAlign: "left",
  ".expanded": {
    marginTop: "1rem",
  },
  "&.level-0": {
    fontFamily: "'Nunito', sans-serif",
  },
}));
